import {Option} from "ts-option";
import Phone from "../../phone/Phone";
import Email from "../../email/Email";

/**
 * Communication channel to individual contact.
 */
export default class IndividualCommunication {

	/**
	 * String using to search a contact.
	 */
	public readonly searchString: string;

	/**
	 * @param {Email[]} emails Array of contact emails.
	 * @param {Phone[]} phoneNumbers Array of phone numbers
	 */
	constructor(public readonly emails: Option<Email[]>,
		public readonly phoneNumbers: Option<Phone[]>) {
		const emailsStr = emails.getOrElse([]).map(email => email.value).join(" ");
		const internationalPhoneNumbers = phoneNumbers.getOrElse([]).map(pn => pn.internationalPhoneNumber).join(" ");
		const nationalPhoneNumbers = phoneNumbers.getOrElse([]).map(pn => pn.nationalPhoneNumber).join(" ");
		this.searchString = `${emailsStr} ${internationalPhoneNumbers} ${nationalPhoneNumbers}`.toLowerCase()
	}
}